import { lazy, Suspense } from "react";

// Defers recharts+d3 (~2MB raw) into an async chunk. Charts use
// ResponsiveContainer (client-sized, empty on the server), so rendering the
// null fallback during SSR and loading after hydration is not a regression.
const AreaGraphImpl = lazy(() => import("./AreaGraph.impl"));

const AreaGraph = (props) => (
  <Suspense fallback={null}>
    <AreaGraphImpl {...props} />
  </Suspense>
);

export default AreaGraph;
